import {BootstrapButton, BootstrapModal} from '../react-bootstrap'
import {sum, bindState} from '../utils'


export class LoginForm extends React.Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);

        this.state = {data: {remember_me: true}};
        this.bindState = bindState;
    }
    componentWillUnmount () {
        this.xhr && this.xhr.abort();
    }
    renderForm() {
        return (
            <div>
                { this.state.errors ?
                    <div className="text-danger">
                        <ul className="list-unstyled">
                            { this.state.errors.map((err, i) => <li key={i}>{ err }</li>) }
                        </ul>
                    </div>
                        : null
                }
				<form className="login-form" autoComplete="off" action="#" onSubmit={this.onSubmit}>
					<div className="form-group">
						<input className="form-control" name="email" value={this.state.data.email} onChange={this.bindState('data.email')} placeholder="Email" />
					</div>
					<div className="form-group">
						<input type="password" className="form-control" name="password" value={this.state.data.password} onChange={this.bindState('data.password')} placeholder="Password" />
					</div>
                    <div className="checkbox">
                        <label>
                            <input type="checkbox" name="remember_me" checked={this.state.data.remember_me} onChange={this.bindState('data.remember_me')} /> Remember me
                        </label>
                        <span className="separator">·</span>
                        <a className="forgot" href="/users/password_reset/begin">Forgot password?</a>
                    </div>
                    <button type="submit" className="btn btn-primary btn-lg btn-block">Log in</button>
                </form>
            </div>
        )
    }
    render () {
        return this.renderForm();
    }
    onLoggedIn() {
    }
    onSubmit (e) {
        e.preventDefault();
        var data = this.state.data;
        this.xhr = $.postJSON('/users/login', data).done(data => {
            this.props.onLoggedIn(data);
            this.onLoggedIn(data);
        }).fail((xhr, textStatus, errorThrown) => {
            if (xhr.status === 400) {
                this.setState({errors:[xhr.responseText]})
            } else {
                this.setState({errors: ['Operation failed.']})
            }
        }).always(() => this.xhr = null);
    }

}

export class LoginModal extends LoginForm {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleCancel () {
        this.refs.modal.close();
    }
    render () {
        var footer = (<span>Don't have an account? <a href="/users/register">Register »</a></span>);

        return (
            <BootstrapModal
                ref="modal"
                className="login"
                onCancel={this.handleCancel}
                onHidden={this.props.onHidden}
                title="Log in to Vnistar"
                footer={footer}>
                <br />
                <div className="row">
                    <div className="col-sm-6 col-sm-offset-3">
                        { this.renderForm() }
                    </div>
                </div>
                <br />
            </BootstrapModal>
        );
    }
    openModal () {
        this.refs.modal.open();
    }
    onLoggedIn () {
        this.refs.modal.close()
    }
}

